export default {
    namespaced: true,
    state: {
        projects: null
    },
    mutations: {
        SET_PROJECTS(state, projects) {
            state.projects = projects
        },
    },
    actions: {
        async fetchProjects({ commit }) {
            const response = await fetch(`${api_url}/projects`, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${this.state.login.session}`
                }
            });
            const projects = await response.json();
            commit('SET_PROJECTS', projects);
        },
    }
};